const Spacers = {
  spacer0: "0rem",
  spacer1: "0.25rem",
  spacer2: "0.5rem",
  spacer3: "0.75rem",
  spacer4: "1rem",
  spacer5: "1.25rem",
  spacer6: "1.5rem",
  spacer7: "1.75rem",
  spacer8: "2rem",
  spacer9: "2.25rem",
  spacer10: "2.5rem",
  spacer11: "2.75rem",
  spacer12: "3rem",
};

export { Spacers };
